import { render, staticRenderFns } from "./MySubmit.vue?vue&type=template&id=f38c9b9e&scoped=true"
import script from "./MySubmit.vue?vue&type=script&lang=js"
export * from "./MySubmit.vue?vue&type=script&lang=js"
import style0 from "./MySubmit.vue?vue&type=style&index=0&id=f38c9b9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38c9b9e",
  null
  
)

export default component.exports